var _G, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgGenericSmartWatch(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 75,
    height: 75,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#generic-smart-watch_svg__clip0_4078_11881)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M37.5 58.594c11.65 0 21.094-9.444 21.094-21.094S49.15 16.406 37.5 16.406 16.406 25.85 16.406 37.5 25.85 58.594 37.5 58.594z",
    stroke: "#333",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M37.125 54c9.113 0 16.5-7.387 16.5-16.5S46.238 21 37.125 21s-16.5 7.387-16.5 16.5S28.012 54 37.125 54z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#generic-smart-watch_svg__clip1_4078_11881)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M28.25 38.813h4.063l1.624-2.438 3.25 4.875 1.626-2.438h2.437"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M27.438 35.563v-.204a5.485 5.485 0 015.484-5.484c2.294 0 4.26 1.25 5.078 3.25.819-2 2.784-3.25 5.078-3.25a5.485 5.485 0 015.484 5.484C48.563 42.062 38 47.75 38 47.75s-4.266-2.295-7.371-5.688"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M25.781 19.96l1.995-11.004a2.343 2.343 0 012.306-1.925h14.836a2.344 2.344 0 012.306 1.925l1.995 11.004M25.781 55.04l1.995 11.004a2.344 2.344 0 002.306 1.925h14.836a2.344 2.344 0 002.306-1.925l1.995-11.004",
    stroke: "#333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "generic-smart-watch_svg__clip0_4078_11881"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h75v75H0z"
  })), /*#__PURE__*/React.createElement(ClipPath, {
    id: "generic-smart-watch_svg__clip1_4078_11881"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "translate(25 25)",
    d: "M0 0h26v26H0z"
  })))));
}

export default SvgGenericSmartWatch;